// Versión visible de Ai-POS (pantalla de carga, soporte remoto y accesos directos de escritorio).
export const APP_VERSION = "2.6.0";
